import type { Backtest } from "../types/backtests";

/** Resolve reporting timezone from slim backtest row (scope → result.meta → legacy payload). */
export function timezoneFromBacktestRow(bt: Backtest | Record<string, unknown>): string | null {
  const row = bt as Record<string, unknown>;
  const scope = row.scope;
  if (scope && typeof scope === "object" && !Array.isArray(scope)) {
    const tz = (scope as Record<string, unknown>).timezone;
    if (typeof tz === "string" && tz.trim()) return tz.trim();
  }
  const result = row.result;
  if (result && typeof result === "object" && !Array.isArray(result)) {
    const meta = (result as Record<string, unknown>).meta;
    if (meta && typeof meta === "object" && !Array.isArray(meta)) {
      const tz = (meta as Record<string, unknown>).timezone;
      if (typeof tz === "string" && tz.trim()) return tz.trim();
    }
  }
  if (typeof row.timezone === "string" && row.timezone.trim()) return row.timezone.trim();
  const payload = row.payload;
  if (payload && typeof payload === "object" && !Array.isArray(payload)) {
    const tz = (payload as Record<string, unknown>).timezone;
    if (typeof tz === "string" && tz.trim()) return tz.trim();
  }
  return null;
}
